export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-3.2505e4f3.png";